<template>
  <v-layout align-center row wrap>
    <v-flex xs12 sm4 class="pr-5">
      {{ label }}
    </v-flex>
    <template v-if="!$slots.default">
      <v-flex xs6 sm4>
        <slot name="min"></slot>
      </v-flex>
      <v-flex xs6 sm4>
        <slot name="max"></slot>
      </v-flex>
    </template>
    <v-flex xs12 sm8 v-else>
      <slot></slot>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['label']
}
</script>
